import type * as Types from '../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteStylistExtractDominantColorsQueryVariables = Types.Exact<{
  input: Types.WebsiteStylistExtractDominantColorsInput;
}>;

export type WebsiteStylistExtractDominantColorsQuery = {
  __typename?: 'Query';
  websiteStylistExtractDominantColors: {
    __typename?: 'WebsiteStylistDominantColors';
    status: Types.WebsiteStylistDominantColorsStatus;
    colors: Array<{
      __typename?: 'WebsiteStylistDominantColor';
      hex: string;
      score: number;
      isNeutral: boolean;
      source: Types.WebsiteStylistDominantColorSource;
      pixelPercent: number;
    }>;
  };
};

export const WebsiteStylistExtractDominantColorsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteStylistExtractDominantColors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteStylistExtractDominantColorsInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteStylistExtractDominantColors' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNeutral' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pixelPercent' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteStylistExtractDominantColorsQuery__
 *
 * To run a query within a React component, call `useWebsiteStylistExtractDominantColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteStylistExtractDominantColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteStylistExtractDominantColorsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWebsiteStylistExtractDominantColorsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteStylistExtractDominantColorsQuery, WebsiteStylistExtractDominantColorsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<WebsiteStylistExtractDominantColorsQuery, WebsiteStylistExtractDominantColorsQueryVariables>(
    WebsiteStylistExtractDominantColorsDocument,
    baseOptions,
  );
}
export function useWebsiteStylistExtractDominantColorsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteStylistExtractDominantColorsQuery, WebsiteStylistExtractDominantColorsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WebsiteStylistExtractDominantColorsQuery, WebsiteStylistExtractDominantColorsQueryVariables>(
    WebsiteStylistExtractDominantColorsDocument,
    baseOptions,
  );
}
export type WebsiteStylistExtractDominantColorsQueryHookResult = ReturnType<typeof useWebsiteStylistExtractDominantColorsQuery>;
export type WebsiteStylistExtractDominantColorsLazyQueryHookResult = ReturnType<typeof useWebsiteStylistExtractDominantColorsLazyQuery>;
export type WebsiteStylistExtractDominantColorsQueryResult = Apollo.QueryResult<WebsiteStylistExtractDominantColorsQuery, WebsiteStylistExtractDominantColorsQueryVariables>;
